package com.fantasytenis.shared.domain.notifications.usecases

import com.fantasytenis.shared.core.utils.SharedData
import com.fantasytenis.shared.domain.notifications.NotificationsRepository

/**
 * Use case for marking a notification as read.
 * Updates SharedData accordingly.
 */
class MarkNotificationReadUseCase(
    private val repository: NotificationsRepository
) {
    /**
     * Mark a notification as read.
     *
     * @param notificationId The ID of the notification to mark as read
     */
    suspend operator fun invoke(notificationId: String): Result<Boolean> = runCatching {
        val success = repository.markAsRead(notificationId)

        if (success) {
            // Update the notification in SharedData
            val current = SharedData.notifications.value
            SharedData.notifications.value = current.map { notification ->
                if (notification.id == notificationId) {
                    notification.copy(read = true)
                } else {
                    notification
                }
            }

            // Decrement unread count
            val count = SharedData.unreadNotificationCount.value
            if (count > 0) {
                SharedData.unreadNotificationCount.value = count - 1
            }
        }

        success
    }
}
